export const STATE_NAME = 'utensils';

export const FETCH_UTENSILS = 'UTENSIL_FETCH_UTENSILS';
export const FETCH_UTENSILS_DONE = 'UTENSIL_FETCH_UTENSILS_DONE';
export const FETCH_UTENSILS_FAIL = 'UTENSIL_FETCH_UTENSILS_FAIL';

// Added to fetch market utensils
export const FETCH_MARKET_UTENSILS = 'FETCH_MARKET_UTENSILS';
export const FETCH_MARKET_UTENSILS_DONE = 'FETCH_MARKET_UTENSILS_DONE';
export const FETCH_MARKET_UTENSILS_FAIL = 'FETCH_MARKET_UTENSILS_FAIL';
